import { render, staticRenderFns } from "./EntrepreneurVideoDecorativeItem.vue?vue&type=template&id=471fd4b9&scoped=true&"
import script from "./EntrepreneurVideoDecorativeItem.vue?vue&type=script&lang=js&"
export * from "./EntrepreneurVideoDecorativeItem.vue?vue&type=script&lang=js&"
import style0 from "./EntrepreneurVideoDecorativeItem.vue?vue&type=style&index=0&id=471fd4b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471fd4b9",
  null
  
)

export default component.exports